<template>
  <v-content>
    <transition
      name="fade-in"
      appear
      :appear-active-class="$vuetify.rtl ? 'ktSlideInRight' : 'ktSlideInLeft'"
      :enter-active-class="$vuetify.rtl ? 'ktSlideInRight' : 'ktSlideInLeft'"
      :leave-active-class="$vuetify.rtl ? 'ktSlideOutRight' : 'ktSlideOutLeft'"
    >
      <dashboard-content v-if="$route.path.toLowerCase() === '/dashboard'" pa-4 class="semi-grey-background" />
      <router-view v-else pa-4 class="semi-grey-background" :key="$route.fullpath" />
    </transition>
  </v-content>
</template>

<script>
import DashboardContentVue from './DashboardContent.vue'

export default {
  components: {
    dashboardContent: DashboardContentVue
  }
}
</script>

<style scoped>
.semi-grey-background {
  background-color: rgba(230, 230, 230, 1) !important;
  padding: 10px 15px;
  min-height: calc(100vh - 100px);
  animation-delay: 1s;
}

.ktSlideInLeft {
  transform: scale(0);
  animation: slideElementInLeft 0.5s ease-in-out;
  animation-delay: 0.5s;
}
@keyframes slideElementInLeft {
  0% {
    transform: translateX(-110%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.ktSlideOutLeft {
  animation: slideElementOutLeft 0.5s ease-in-out;
}
@keyframes slideElementOutLeft {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  70% {
    opacity: 0;
  }
  100% {
    transform: translateX(-110%);
    opacity: 0;
  }
}

.ktSlideInRight {
  transform: scale(0);
  animation: slideElementInRight 0.5s ease-in-out;
  animation-delay: 0.5s;
}
@keyframes slideElementInRight {
  0% {
    transform: translateX(110%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.ktSlideOutRight {
  animation: slideElementOutRight 0.5s ease-in-out;
}
@keyframes slideElementOutRight {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  70% {
    opacity: 0;
  }
  100% {
    transform: translateX(110%);
    opacity: 0;
  }
}
</style>
